'use strict';

/** @type {import('./max')} */
module.exports = Math.max;



//////////////////
// WEBPACK FOOTER
// ./node_modules/math-intrinsics/max.js
// module id = 1542
// module chunks = 8